import { createClient } from '@supabase/supabase-js';

// Project ID is injected during deployment.
const SUPABASE_URL = 'https://awdhtrppobcwsbinqlaq.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF3ZGh0cnBwb2Jjd3NiaW5xbGFxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTAwODU4NTMsImV4cCI6MjEwNTY2MTg1M30.cvSMed5_zBGbm7N1GUACWkOSX8Mv4WrRtHz5FLr17pA';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});